module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/spk-controls-example/spk-controls-example.component.scss
// module id = ./src/app/components/examples/spk-controls-example/spk-controls-example.component.scss
// module chunks = main